import { render, staticRenderFns } from "./DocumentView.vue?vue&type=template&id=6c1fe3a6&"
import script from "./DocumentView.vue?vue&type=script&lang=ts&"
export * from "./DocumentView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports